export default "__VITE_ASSET__DAF$LMSD__"